


































import { defineComponent, PropType, ref } from "@vue/composition-api";
import { LiveChatInvitationSubjectType } from "@scrile/api-provider/dist/api/LiveChatInvitationsProvider";
import { UserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import providers from "@/lib/api";
import { $t } from "@/lib/i18nHelpers";
import { getCollabLiveUrl } from "@/lib/urlHelpers";
import { Tab } from "@/types";
import { MAX_COLLAB_INVITES } from "@/const";
import BaseButton from "@/components/BaseButton";
import BaseSegmentedButton from "@/components/BaseSegmentedButton";
import PageTitle from "@/components/PageTitle";
import UserSearchAndSelect from "@/components/UserSearchAndSelect";
import useLiveChatInvitation from "../../../hooks/useLiveChatInvitation";

export default defineComponent({
  name: "ChangeLiveMode",
  components: { UserSearchAndSelect, BaseButton, BaseSegmentedButton, PageTitle },
  props: {
    user: { type: Object as PropType<UserPublicData>, required: true },
  },
  setup(props, { root, emit }) {
    const loading = ref(false);
    const { invitationsCreate } = useLiveChatInvitation();
    const activeType = ref<LiveChatInvitationSubjectType>(LiveChatInvitationSubjectType.COLLAB);
    const selectedUserIds = ref<string[]>([]);

    const tabs: Tab[] = [
      {
        text: $t("Collab"),
        value: LiveChatInvitationSubjectType.COLLAB,
      },
    ];

    const changeMode = async () => {
      try {
        loading.value = true;
        const collabLive = await providers.CollabLiveChatsProvider.create();

        if (selectedUserIds.value.length > 0) {
          await invitationsCreate({
            chatId: collabLive.id,
            type: activeType.value,
            recipientIds: selectedUserIds.value,
          });
        }
        root.$router.replace(getCollabLiveUrl(props.user, collabLive.id));
        emit("close");
      } finally {
        loading.value = false;
      }
    };

    return { loading, activeType, tabs, selectedUserIds, MAX_COLLAB_INVITES, changeMode };
  },
});
